export const environment = {
  production: false,
  API_URL: (<any>window)._titan_registration_service_env.API_URL,
  LOCATION_HANDLER: (<any>window)._titan_registration_service_env
    .LOCATION_HANDLER,
  SyncfusionLicence:
    'ORg4AjUWIQA/Gnt2VVhhQlFacF5JXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkJiWn5bcnRQRWleV0w=',
  AppCode: (<any>window)._titan_registration_service_env.APP_CODE,
};
